/*
 * @fileOverView Share component definition
 */

import Vue from 'vue';
import Throttle from 'utils/Throttle';
import {Events, Intervals, Distances} from 'utils/Constants';
import Addthis from 'components/modules/utility/share/addthis.mixin';
import Analytics from 'mixins/analytics.mixin';

/**
 * Share component
 *
 * @type {class}
 */
Vue.component('share-vue', {
  mixins:[
    Addthis,
    Analytics
  ],

  data: function() {
    return {
      currentScrollPosition: 0
    }
  },

  computed: {
    /**
     * Determines whether or not the element should be visible.
     *
     * @return {bool} true if it should be visible, otherwise false.
     */
    isVisible: function() {
      return this.currentScrollPosition > Distances.SCROLL_VISIBILITY_TRIGGER;
    }
  },

  mounted() {
    this.$window = $(window);
    this.$window.on(Events.SCROLL, Throttle(e => this.handleWindowScroll(e), Intervals.SCROLL_INTERVAL));
    this.handleWindowScroll();
  },

  methods: {
    handleShare(e) {
      const service = e.target.getAttribute('data-service');
      const pageName = window.mjffPageData ? window.mjffPageData.pageName : null;

      this.pushSocialSharedEvent(service, `page:${pageName}`);
    },

    /**
     * Handles the window scroll event.
     *
     * @param {Object} e - Javascript event object
     */
    handleWindowScroll(e) {
      this.currentScrollPosition = this.$window.scrollTop();
    },

    /**
     * Handles scroll animation and tab focus.
     *
     * @param {Object} e - Javascript event object
     */
    handleReturnToTop(e) {
      this.scrollToTop(e);
      this.focusToTop();
    },

    /**
     * Scrolls the user to the top of the page.
     *
     * @param  {Object} e - Javascript event object
     */
    scrollToTop(e) {
      $('html, body').animate({ scrollTop: 0 }, 500);
    },

    /**
     * Focuses on the first focusable button on the page.
     *
     * @method focusToTop
     */
    focusToTop() {
      document.querySelectorAll('button, [tabindex]:not([tabindex="-1"])')[0].focus();
    },

    /**
     * Handles toggling the subcontrols in a button that has them.
     *
     * @param {Object} e - Javascript event object
     */
    toggleSubcontrols(e) {
      e.currentTarget.nextElementSibling.classList.toggle('share-subcontrols_visible');
    }
  }
});
